import axiosInstance from 'api/base';

const CardIssuingOrganisationApi = {
  async getIssuingOrganisations(countryCode: string): Promise<string[]> {
    const response = await axiosInstance.get<{ result: string[] }>(
      'routing-rulesets/issuing-orgs',
      {
        params: { countryCode },
      },
    );

    return response.data?.result || [];
  },
};

export default CardIssuingOrganisationApi;
